import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";
import { Images } from "config/images";

const PointLoyalty = props => {
	const classes = useStyles();
	const { point } = props;
	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.title }}>
				<Grid>
					<img src={Images.icLoyalty} alt="icLoyalty" />
				</Grid>
				<Grid>Điểm tích lũy từ đơn hàng</Grid>
			</Grid>
			<Grid classes={{ root: classes.point }}>{formatCash(point)}</Grid>
		</Grid>
	);
};

export default memo(PointLoyalty);
